import { openPopupPromise } from './popups/popupOpenClose';
import StateObserver from '../StateObserver';
import i18n from './i18n/i18n';
import platform from '@play-co/gcinstant';
import { isPlatformNative, logoutNativeApp } from './native/native.util';

export async function startDeleteAccountSequence() {
  await StateObserver.invoke.setDeleteAccountIntent(true);

  const isConfirmed = await openPopupPromise('popupConfirmation', {
    title: i18n('deleteAccount.title'),
    message: i18n('deleteAccount.message'),
    buttonOkay: i18n('deleteAccount.ok'),
    buttonCancel: i18n('deleteAccount.cancel'),
  });
  if (!isConfirmed) {
    await StateObserver.invoke.setDeleteAccountIntent(false);
    return;
  }

  try {
    await StateObserver.invoke.deleteAccount();
    await StateObserver.replicant.flush();
    platform.quit();

    if (isPlatformNative()) {
      logoutNativeApp();
    } else {
      window.location.reload();
    }
  } catch (e) {
    await openPopupPromise('popupReplicationError', {
      message: e.message ?? e,
    });
  }
}
